<div class="image-inner" [ngSwitch]="cardsFormat">
  <app-template-card 
      [cardTemplate]="cardTemplate" 
      [cardFormat]="cardsFormat" 
      [lessonDate]="lessonDate"
      [box]="box"
      [boxLevels]="boxLevels"
      [character]="character">
  </app-template-card>
  <span class="format" [ngStyle]="{'font-size': '80px'}" *ngSwitchCase="'A7'">A7</span>
  <span class="format" *ngSwitchCase="'A6'">A6</span>
  <span class="format" *ngSwitchCase="'A5'">A5</span>
  <span class="format" [ngStyle]="{'font-size': '65px'}" *ngSwitchCase="'A3'">1/6</span>
</div>
